export const fetchWithFallback = async (path, options = {}) => {
    const primaryUrl = `https://rosemount-staff.onrender.com${path}`;
    const fallbackUrl = `http://localhost:3000${path}`;

    // console.log("Primary URL:", primaryUrl);
    // console.log("Fallback URL:", fallbackUrl);
  
    try {
      const res = await fetch(primaryUrl, options);
      if (!res.ok) throw new Error("Primary server failed");
      return await res.json();
    } catch (err) {
      console.warn("Primary server failed, retrying with localhost...", err.message);
      const fallbackRes = await fetch(fallbackUrl, options);
      if (!fallbackRes.ok) throw new Error("Fallback server failed");
      return await fallbackRes.json();
    }
  };
  